export default __webpack_public_path__ + "static/googleIcon-39c52b1bcccb20569aa4ea620fdc6b69.png";